import React from "react";
import { Modal, Divider } from "@mui/material";
import { styled } from '@mui/material/styles';
import { Box } from "@mui/system";
import { EsgFileIcon } from "assets";
import { Label16SemiBold, CloseButton, PrimaryLabel, EsgPrimaryLabel, Body1Regular } from "components";
import { AUDIT_LOGS_EVENT, AUDIT_LOGS_COLOR } from "consts";
import moment from "moment";
import { Link } from "react-router-dom";
import { isValidISODate } from "utils";


const ScrollableBox = styled(Box)(({ theme }) => ({
    border: '1px solid #C1C5CE',
    borderRadius: "8px",
    marginTop: "8px",
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    overflowY: 'scroll',
    padding: theme.spacing(1),
    '&::-webkit-scrollbar': {
        marginTop: "12px",
        width: '8px',
    },
    '&::-webkit-scrollbar-track': {
        background: 'transparent',
        borderRadius: '14px',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#f1f1f1',
        borderRadius: '6px',
    }
}));

const AuditLogsDetailsModal = ({ handleClose, isOpen, data }: { handleClose: () => void, isOpen: boolean, data: any }) => {
    const context = JSON.parse(data?.context);
    const parentData = context?.parentData;
    const generalInfoPanel = [
        {
            title: "Activity Type",
            value: data?.eventType
        },
        {
            title: "Resources Affected",
            value: data?.className
        },
        {
            title: "User",
            value: data?.userName
        },
        {
            title: "Date Created",
            value: moment(data?.createDate).format('MM/DD/YYYY HH:mm:ss')
        },
    ]
    return <Modal
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
    >
        <Box sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            height: "80%",
            bgcolor: "background.paper",
            boxShadow: 24,
            zIndex: 999,
            display: "flex",
            flexDirection: "column",
            padding: '25px 0',
            gap: '12px'
        }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 25px' }}>
                <Label16SemiBold>
                    View Details
                </Label16SemiBold>
                <CloseButton onClick={() => handleClose()} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', backgroundColor: '#F6F8FA', padding: '16px 25px', gap: '15px' }}>
                {generalInfoPanel.map(({ title, value }) => <div style={{ width: '25%', lineBreak: 'anywhere' }}>
                    <PrimaryLabel>{title}</PrimaryLabel>
                    {title === 'Resources Affected' && value === "Bill" ?
                        <Link style={{ textDecoration: 'none', color: 'black' }} target="_blank" to={`/documents/summary/${data?.persistedObjectId}`}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <EsgFileIcon />
                                <EsgPrimaryLabel sx={{ mt: 1 }}>{value}</EsgPrimaryLabel>
                            </Box>
                        </Link>
                        : <EsgPrimaryLabel sx={{ mt: 1 }}>{value}</EsgPrimaryLabel>
                    }
                </div>)}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%', padding: '25px', overflow: 'hidden' }}>
                {parentData && <div style={{ width: '100%' }}>
                    {Object?.entries(parentData)?.map(([key, values]) => (
                        <div key={key}>
                            <strong>{key}:</strong> <span style={{ fontSize: '14px', fontStyle: 'Inter' }}>{isValidISODate(values as string) ? moment(values as any).format("MM/DD/YYYY") : values as any}</span>
                        </div>
                    ))}
                    <Divider sx={{ my: 1 }} />
                </div>

                }
                <Body1Regular>{AUDIT_LOGS_EVENT[data?.eventType]}</Body1Regular>
                <ScrollableBox>
                    {Object.keys(context).map((key) => {
                        if (key === "parentData") {
                            return null; // Don't render if key matches parentData
                        }
                        return (
                            <Box
                                sx={{
                                    padding: '8px 12px',
                                    gap: '10px',
                                    borderRadius: '6px',
                                    boxSizing: 'border-box',
                                    backgroundColor: AUDIT_LOGS_COLOR[data?.eventType],
                                    mt: Object.keys(context).length > 1 ? 1 : '',
                                }}
                            >
                                {data?.eventType === "UPDATE" ? (
                                    <li key={key}>
                                        {key} :{" "}
                                        {context[key].oldValue && isValidISODate(context[key].newValue) ? (
                                            <>
                                                <span style={{ fontSize: '13px' }}>Changed From</span> <strong>{moment(context[key].oldValue).format("DD-MM-YYYY")}</strong> <span style={{ fontSize: '13px' }}>to</span> {" "}
                                                <strong>{moment(context[key].newValue).format("DD-MM-YYYY")}</strong>
                                            </>
                                        ) : (
                                            <>
                                                <span style={{ fontSize: '13px' }}>Changed From</span> <strong>{context[key].oldValue}</strong> <span style={{ fontSize: '13px' }}>to</span>{" "}
                                                <strong>{context[key].newValue}</strong>
                                            </>
                                        )}
                                    </li>
                                ) : (
                                    <li key={key}>
                                        {key} :{" "}
                                        {context[key].oldValue && <strong>{context[key].oldValue}</strong>}{" "}
                                        {isValidISODate(context[key].newValue) ? (
                                            <strong>{moment(context[key].newValue).format("DD-MM-YYYY")}</strong>
                                        ) : (
                                            <strong>{context[key].newValue}</strong>
                                        )}
                                    </li>
                                )}
                            </Box>
                        )
                    })}
                </ScrollableBox>
            </div>
        </Box>
    </Modal>
}

export default AuditLogsDetailsModal;